import React from 'react';
import {
  TICKETS_ROUTE,
  REQUEST_NOT_PRODUCT_TICKET,
} from '../../../../constants/Routes';
import TicketIcon from '../../../common/icons/ticketIcon';
import MakeRequestIcon from '../../../common/icons/MakeRequestIcon';
import { showReportIssueNoProduct } from '../../../../constants/Visible';

export const ticketGroup = () => {
  return showReportIssueNoProduct === 'on'
    ? [
        ...ticketGroupBase,
        {
          route: REQUEST_NOT_PRODUCT_TICKET,
          icon: <MakeRequestIcon size="30px" />,
          title: 'Realizar solicitud',
          id: 'reportIssueSection',
        },
      ]
    : ticketGroupBase;
};

export const ticketGroupBase = [
  {
    route: TICKETS_ROUTE,
    icon: <TicketIcon size="30px" />,
    title: 'Solicitudes de atención',
    id: 'lookIssuesSection',
  },
];
